import { render, staticRenderFns } from "./admin_orderDetail.vue?vue&type=template&id=307d8f96&scoped=true"
import script from "./admin_orderDetail.vue?vue&type=script&lang=js"
export * from "./admin_orderDetail.vue?vue&type=script&lang=js"
import style0 from "./admin_orderDetail.vue?vue&type=style&index=0&id=307d8f96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307d8f96",
  null
  
)

export default component.exports